import React, { useMemo } from "react";

export default function AdminWalletFilters({
  scope,       
  setScope,    
  tab,
  setTab,
  q,
  setQ,
  type,
  setType,
  onRefresh,
}) {
  const tabs = useMemo(() => {
    // transfers queue does NOT have "failed"
    return scope === "transactions"
      ? [
          { key: "pending", label: "En attente" },
          { key: "completed", label: "Confirmées" },
          { key: "failed", label: "Rejetées" },
          { key: "cancelled", label: "Annulées" },
        ]
      : [
          { key: "pending", label: "En attente" },
          { key: "completed", label: "Confirmées" },
          { key: "cancelled", label: "Annulées" },
        ];
  }, [scope]);

  function switchScope(next) {
    setScope(next);

    if (next === "transfers") setType("");

    const allowed =
      next === "transactions"
        ? ["pending", "completed", "failed", "cancelled"]
        : ["pending", "completed", "cancelled"];

    if (!allowed.includes(tab)) setTab("pending");
  }

  return (
    <section className="rounded-2xl border border-black/5 dark:border-white/10 bg-white dark:bg-slate-900 shadow-sm p-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-base font-semibold text-slate-900 dark:text-white">
            Wallet — Admin
          </h2>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            {scope === "transactions"
              ? "Validez les opérations wallet (fund, withdraw, loan, ledger)."
              : "Validez les transferts wallet-to-wallet (file d'attente)."}
          </p>
        </div>

        <button
          onClick={onRefresh}
          className="rounded-2xl border border-black/10 dark:border-white/10 bg-white dark:bg-slate-900 px-4 py-2 text-sm font-medium
                     text-slate-900 dark:text-white hover:bg-black/5 dark:hover:bg-white/10 transition"
        >
          Rafraîchir
        </button>
      </div>

      <div className="mt-4 flex flex-col lg:flex-row gap-3">
        {/* SCOPE SWITCH + TABS */}
        <div className="flex flex-col gap-3 w-full lg:w-auto">
          <ScopeSwitch scope={scope} onChange={switchScope} />
          <Tabs items={tabs} tab={tab} setTab={setTab} />
        </div>

        <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-3">
          <div className="md:col-span-2">
            <label className="block text-xs text-slate-500 dark:text-slate-400 mb-1">
              Rechercher (ref / userId / téléphone / email)
            </label>
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Ex: TRF..., FND..., 8582, +237..., user@email.com"
              className={inputCls}
            />
          </div>

          {/* TYPE FILTER ONLY FOR TRANSACTIONS */}
          {scope === "transactions" ? (
            <div>
              <label className="block text-xs text-slate-500 dark:text-slate-400 mb-1">
                Type (transactions)
              </label>
              <select
                value={type}
                onChange={(e) => setType(e.target.value)}
                className={inputCls}
              >
                <option value="">Tous</option>
                <option value="fund">Fund</option>
                <option value="withdraw">Withdraw</option>
                <option value="loan">Loan</option>
                <option value="transfer_out">Transfer out (ledger)</option>
                <option value="transfer_in">Transfer in (ledger)</option>
              </select>

              <p className="mt-1 text-[11px] text-slate-500 dark:text-slate-400">
                Tip: Les transferts à approuver sont dans “Transfers (en attente)”.
              </p>
            </div>
          ) : (
            <div>
              <label className="block text-xs text-slate-500 dark:text-slate-400 mb-1">
                Type
              </label>
              <div className="rounded-2xl border border-black/10 dark:border-white/10 bg-slate-50 dark:bg-white/5 px-4 py-3 text-sm text-slate-600 dark:text-slate-300">
                Transfers en attente de validation
              </div>
              <p className="mt-1 text-[11px] text-slate-500 dark:text-slate-400">
                Ici, on modère les transfers wallet-to-wallet. Les autres types d'opérations (fund, withdraw, loan) sont dans “Transactions”.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

function ScopeSwitch({ scope, onChange }) {
  return (
    <div className="flex rounded-2xl border border-black/10 dark:border-white/10 overflow-hidden w-full lg:w-auto">
      <button
        onClick={() => onChange("transactions")}
        className={
          "px-4 py-2 text-sm font-medium transition flex-1 " +
          (scope === "transactions"
            ? "bg-slate-900 text-white dark:bg-white dark:text-slate-900"
            : "bg-white text-slate-900 hover:bg-black/5 dark:bg-slate-900 dark:text-white dark:hover:bg-white/10")
        }
      >
        Transactions
      </button>
      <button
        onClick={() => onChange("transfers")}
        className={
          "px-4 py-2 text-sm font-medium transition flex-1 " +
          (scope === "transfers"
            ? "bg-slate-900 text-white dark:bg-white dark:text-slate-900"
            : "bg-white text-slate-900 hover:bg-black/5 dark:bg-slate-900 dark:text-white dark:hover:bg-white/10")
        }
      >
        Transfers (en attente)
      </button>
    </div>
  );
}

function Tabs({ items, tab, setTab }) {
  return (
    <div className="flex rounded-2xl border border-black/10 dark:border-white/10 overflow-hidden w-full lg:w-auto">
      {items.map((it) => (
        <button
          key={it.key}
          onClick={() => setTab(it.key)}
          className={
            "px-4 py-2 text-sm font-medium transition flex-1 lg:flex-none " +
            (tab === it.key
              ? "bg-slate-900 text-white dark:bg-white dark:text-slate-900"
              : "bg-white text-slate-900 hover:bg-black/5 dark:bg-slate-900 dark:text-white dark:hover:bg-white/10")
          }
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}

const inputCls =
  "w-full rounded-2xl border border-black/10 dark:border-white/10 bg-white dark:bg-slate-950 px-4 py-3 text-slate-900 dark:text-white outline-none " +
  "focus:ring-2 focus:ring-slate-900/10 dark:focus:ring-white/10";